"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLOW_NODE_SPECS = exports.FlowNodeType = exports.FlowNodeSpec = void 0;
const tslib_1 = require("tslib");
const api_trigger_1 = tslib_1.__importDefault(require("./api-trigger"));
const schedule_trigger_1 = tslib_1.__importDefault(require("./schedule-trigger"));
const app_event_trigger_1 = tslib_1.__importDefault(require("./app-event-trigger"));
const data_record_created_trigger_1 = tslib_1.__importDefault(require("./data-record-created-trigger"));
const data_record_updated_trigger_1 = tslib_1.__importDefault(require("./data-record-updated-trigger"));
const data_record_deleted_trigger_1 = tslib_1.__importDefault(require("./data-record-deleted-trigger"));
const list_data_records_1 = tslib_1.__importDefault(require("./list-data-records"));
const lookup_data_record_1 = tslib_1.__importDefault(require("./lookup-data-record"));
const find_or_create_data_record_1 = tslib_1.__importDefault(require("./find-or-create-data-record"));
const find_data_records_1 = tslib_1.__importDefault(require("./find-data-records"));
const find_data_record_by_id_1 = tslib_1.__importDefault(require("./find-data-record-by-id"));
const create_data_record_1 = tslib_1.__importDefault(require("./create-data-record"));
const update_data_record_1 = tslib_1.__importDefault(require("./update-data-record"));
const delete_data_record_1 = tslib_1.__importDefault(require("./delete-data-record"));
const transform_data_1 = tslib_1.__importDefault(require("./transform-data"));
const filter_1 = tslib_1.__importDefault(require("./filter"));
const create_data_link_1 = tslib_1.__importDefault(require("./create-data-link"));
const find_data_link_1 = tslib_1.__importDefault(require("./find-data-link"));
const for_each_1 = tslib_1.__importDefault(require("./for-each"));
const run_javascript_1 = tslib_1.__importDefault(require("./run-javascript"));
const custom_api_request_1 = tslib_1.__importDefault(require("./custom-api-request"));
const integration_specific_operation_1 = tslib_1.__importDefault(require("./integration-specific-operation"));
const http_request_1 = tslib_1.__importDefault(require("./http-request"));
var base_1 = require("./base");
Object.defineProperty(exports, "FlowNodeSpec", { enumerable: true, get: function () { return base_1.FlowNodeSpec; } });
var FlowNodeType;
(function (FlowNodeType) {
    FlowNodeType["ApiTrigger"] = "api-trigger";
    FlowNodeType["ScheduleTrigger"] = "schedule-trigger";
    FlowNodeType["AppEventTrigger"] = "app-event-trigger";
    FlowNodeType["DataRecordCreatedTrigger"] = "data-record-created-trigger";
    FlowNodeType["DataRecordUpdatedTrigger"] = "data-record-updated-trigger";
    FlowNodeType["DataRecordDeletedTrigger"] = "data-record-deleted-trigger";
    FlowNodeType["TransformData"] = "transform-data";
    FlowNodeType["ListDataRecords"] = "list-data-records";
    FlowNodeType["FindOrCreateDataRecord"] = "find-or-create-data-record";
    FlowNodeType["LookupDataRecord"] = "lookup-data-record";
    FlowNodeType["FindDataRecordById"] = "find-data-record-by-id";
    FlowNodeType["CreateDataRecord"] = "create-data-record";
    FlowNodeType["UpdateDataRecord"] = "update-data-record";
    FlowNodeType["DeleteDataRecord"] = "delete-data-record";
    FlowNodeType["HttpRequest"] = "http-request";
    FlowNodeType["Filter"] = "filter";
    FlowNodeType["CreateDataLink"] = "create-data-link";
    FlowNodeType["FindDataLink"] = "find-data-link";
    FlowNodeType["ForEach"] = "for-each";
    FlowNodeType["RunJavascript"] = "run-javascript";
    FlowNodeType["IntegrationSpecificOperation"] = "integration-specific-operation";
    FlowNodeType["CustomApiRequest"] = "custom-api-request";
    FlowNodeType["FindDataRecords"] = "find-data-records";
})(FlowNodeType = exports.FlowNodeType || (exports.FlowNodeType = {}));
exports.FLOW_NODE_SPECS = {
    [FlowNodeType.ApiTrigger]: api_trigger_1.default,
    [FlowNodeType.ScheduleTrigger]: schedule_trigger_1.default,
    [FlowNodeType.AppEventTrigger]: app_event_trigger_1.default,
    [FlowNodeType.DataRecordCreatedTrigger]: data_record_created_trigger_1.default,
    [FlowNodeType.DataRecordUpdatedTrigger]: data_record_updated_trigger_1.default,
    [FlowNodeType.DataRecordDeletedTrigger]: data_record_deleted_trigger_1.default,
    [FlowNodeType.ListDataRecords]: list_data_records_1.default,
    [FlowNodeType.LookupDataRecord]: lookup_data_record_1.default,
    [FlowNodeType.FindOrCreateDataRecord]: find_or_create_data_record_1.default,
    [FlowNodeType.FindDataRecords]: find_data_records_1.default,
    [FlowNodeType.FindDataRecordById]: find_data_record_by_id_1.default,
    [FlowNodeType.CreateDataRecord]: create_data_record_1.default,
    [FlowNodeType.UpdateDataRecord]: update_data_record_1.default,
    [FlowNodeType.DeleteDataRecord]: delete_data_record_1.default,
    [FlowNodeType.TransformData]: transform_data_1.default,
    [FlowNodeType.Filter]: filter_1.default,
    [FlowNodeType.HttpRequest]: http_request_1.default,
    [FlowNodeType.CreateDataLink]: create_data_link_1.default,
    [FlowNodeType.FindDataLink]: find_data_link_1.default,
    [FlowNodeType.ForEach]: for_each_1.default,
    [FlowNodeType.RunJavascript]: run_javascript_1.default,
    [FlowNodeType.CustomApiRequest]: custom_api_request_1.default,
    [FlowNodeType.IntegrationSpecificOperation]: integration_specific_operation_1.default,
};
//# sourceMappingURL=index.js.map